import apiClient from '../utils/apiClient';

class PeopleApiService {
  /**
   * get employee info
   * @returns {Object}
   */
  public async getEmployeeInfo(login: string) {
    return await apiClient.get(`employee/login/${login}`);
  }
}

export default new PeopleApiService();
